export const EMAIL_VERIFICATION_REQUIRED_EVENT_NAME = 'zoofizjo:email-verification-required';
